/**
 * Global keyboard shortcuts.
 * Cmd+K: Command Palette (all platforms)
 * Cmd+1/2/3: View switching (Tauri only)
 */

import { useEffect } from "react";
import { useLocation } from "wouter";
import { isTauri } from "./usePlatform";
import { useUIStore } from "@/stores/uiStore";

export function useKeyboardShortcuts() {
  const [, setLocation] = useLocation();
  const toggleCommandPalette = useUIStore((s) => s.toggleCommandPalette);

  useEffect(() => {
    function handleKeyDown(e: KeyboardEvent) {
      const mod = e.metaKey || e.ctrlKey;
      if (!mod) return;

      // Cmd+K — Command Palette (all platforms)
      if (e.key === "k") {
        e.preventDefault();
        toggleCommandPalette();
        return;
      }

      // Tauri-only shortcuts
      if (!isTauri()) return;

      switch (e.key) {
        case "1":
          e.preventDefault();
          setLocation("/");
          break;
        case "2":
          e.preventDefault();
          setLocation("/world");
          break;
        case "3":
          e.preventDefault();
          setLocation("/preview");
          break;
      }
    }

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [setLocation, toggleCommandPalette]);
}
